


































































































































































import CtrlAddBtn from '@/components/common/control/CtrlAddBtn.vue';
import CtrlDatePicker from '@/components/common/control/CtrlDatePicker.vue';
import CtrlMessageDialog from '@/components/common/control/CtrlMessageDialog.vue';
import CtrlNormalBtn from '@/components/common/control/CtrlNormalBtn.vue';
import CtrlNormalTxt from '@/components/common/control/CtrlNormalTxt.vue';
import CtrlNumTxt from '@/components/common/control/CtrlNumTxt.vue';
import CtrlSelect from '@/components/common/control/CtrlSelect.vue';
import G_090_ZaikoIdoIraiEntry_ChildDetailInput from '@/components/G_kaigai/G_090_ZaikoIdoIraiEntry_ChildDetailInput.vue';
import G_090_ZaikoIdoIraiEntry_ChildHeaderInput_Table from '@/components/G_kaigai/G_090_ZaikoIdoIraiEntry_ChildHeaderInput_Table.vue';
import { Flg, OutStatus, ShoriKb, UmuFlg } from '@/constants/constants';
import { BUTTON } from '@/constants/label';
import {
  convertStr2Num,
  dateStrToNum,
  isShorikbADD,
  isShorikbREFER,
  isShorikbUPD,
} from '@/utils/utils';
import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend<any, any, any, any>({
  name: 'G_090_ZaikoIdoIraiEntry_ChildHeaderInput',
  components: {
    CtrlDatePicker,
    CtrlNormalBtn,
    CtrlMessageDialog,
    CtrlNormalTxt,
    G_090_ZaikoIdoIraiEntry_ChildHeaderInput_Table,
    G_090_ZaikoIdoIraiEntry_ChildDetailInput,
    CtrlSelect,
    CtrlAddBtn,
    CtrlNumTxt,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    shoriKb: {
      type: Number,
      default: ShoriKb.ADD,
    },
    childItem: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    BUTTON,
    Flg,
    childHeaderInput: {
      zaikoIdoIraiJigyoshoCd: 0,
      zaikoIdoIraiEntryYmd: 0,
      zaikoIdoIraiNo: 0,
      zaikoIdoIraiShuseiCount: 0,
      orderNo: '',
      nyukoSokoCd: 0,
      gyoshuCd: 0,
      zaikoIdoIraiBiko: '',
      koshinCountDetailSum: 0,
      zaikoIdoIraiD: [],
      jotai: '',
    },
    gyoshuItems: [],
    shukasakiSokoItems: [],
    childDetailShoriKb: ShoriKb.ADD,
    childDetailInputItem: {},
    childDetailInputShow: false,
    messageShow: false,
    messageId: '',
    messageTextParam: [],
    messageConfirmSubmit: false,
    isReload: false,
  }),
  computed: {
    ...mapGetters({
      userInfo: 'common/userInfo',
      childHeaderTitle: 'common/childHeaderTitle',
    }),
    isAdd() {
      return isShorikbADD(this.shoriKb);
    },
    isUpd() {
      return isShorikbUPD(this.shoriKb);
    },
    isRef() {
      return isShorikbREFER(this.shoriKb);
    },
  },
  methods: {
    hide(reload = true) {
      this.$emit('update:show', false);
      this.$emit('hide', reload);
    },
    handleOkMessage() {
      this.messageShow = false;
      this.messageId = '';
      this.messageTextParam = [];
      if (this.isReload) {
        this.hide();
      }
      if (this.messageConfirmSubmit) {
        this.messageConfirmSubmit = false;
        this.handleSubmit();
      }
    },
    handleCancelMessage() {
      this.messageConfirmSubmit = false;
    },
    async handleDelete() {
      this.$store.dispatch('common/setIsLoading', true);
      const {
        zaikoIdoIraiJigyoshoCd,
        zaikoIdoIraiEntryYmd,
        zaikoIdoIraiNo,
        zaikoIdoIraiShuseiCount,
        koshinCountDetailSum,
      } = this.childItem;

      const params = {
        zaikoIdoIraiJigyoshoCd,
        zaikoIdoIraiEntryYmd: dateStrToNum(zaikoIdoIraiEntryYmd),
        zaikoIdoIraiNo: zaikoIdoIraiNo,
        zaikoIdoIraiShuseiCount,
        jigyoshoCd: this.userInfo.jigyoshoData.jigyoshoCd,
        genzaiYmd: this.userInfo.onlineData.genzaiYmd,
        koshinCountDetailSum,
      };
      this.$store.dispatch('common/setIsLoading', false);
      const res = await this.$store.dispatch(
        'g090/deleteZaikoIdoIraiEntryItem',
        params
      );
      const { error } = res.data;
      if (
        res &&
        res.status == 200 &&
        res.data &&
        res.data.error &&
        res.data.error.messageID &&
        res.data.error.outStatus &&
        res.data.error.outStatus != OutStatus.NORMAL
      ) {
        if (error.outStatus == OutStatus.CHECK_ERR) {
          this.messageShow = true;
          this.messageId = error.messageID;
          this.messageTextParam = error.messageArgs;
          return;
        } else if (error.outStatus == OutStatus.EXCLUSIVE_ERR) {
          this.messageShow = true;
          this.messageId = error.messageID;
          this.messageTextParam = error.messageArgs;
          this.isReload = true;
          return;
        }
      }
      this.hide();
    },
    handleAdd() {
      if (!this.childHeaderInput.gyoshuCd) {
        this.messageId = 'KI_W100';
        this.messageTextParam = ['業種'];
        this.messageShow = true;
        return;
      }
      this.childDetailInputItem = {
        gyoshuCd: this.childHeaderInput.gyoshuCd,
      };
      this.childDetailShoriKb = ShoriKb.ADD;
      this.childDetailInputShow = true;
    },
    handleInfo(item: any) {
      this.childDetailInputItem = item;
      this.childDetailShoriKb = ShoriKb.REFER;
      this.childDetailInputShow = true;
    },
    handleEdit(item: any) {
      this.childDetailInputItem = {
        ...item,
        gyoshuCd: this.childHeaderInput.gyoshuCd,
      };
      this.childDetailShoriKb = ShoriKb.UPD;
      this.childDetailInputShow = true;
    },
    handleDeleteChildItem(item: any) {
      this.childHeaderInput.zaikoIdoIraiD.splice(item.index, 1);
    },
    handleSaveChildItem(newItem: any) {
      if (this.childDetailShoriKb === ShoriKb.UPD) {
        this.childHeaderInput.zaikoIdoIraiD =
          this.childHeaderInput.zaikoIdoIraiD.map(
            (item: any, index: number) => {
              if (index === newItem.index) {
                return newItem;
              }
              return item;
            }
          );
      } else {
        this.childHeaderInput.zaikoIdoIraiD.push(newItem);
      }
    },
    async handleSubmit() {
      // ローディング・スタート
      this.$store.dispatch('common/setIsLoading', true);
      const childHeaderInput = this.childHeaderInput;
      const {
        zaikoIdoIraiJigyoshoCd,
        zaikoIdoIraiEntryYmd,
        zaikoIdoIraiNo,
        zaikoIdoIraiShuseiCount,
        nyukoSokoCd,
        nyukoKiboYmd,
        zaikoIdoIraiBiko,
        zaikoIdoIraiD,
      } = childHeaderInput;
      const detailData = zaikoIdoIraiD.map((item: any, index: number) => ({
        zaikoIdoIraiGyoNo: index + 1,
        himmokuCd: +item.himmokuCd,
        nensan: +item.nensan,
        idoSuryo: convertStr2Num(item.idoSuryo),
        idoJuryo: convertStr2Num(item.idoJuryo),
        meisaiBiko: item.meisaiBiko,
      }));

      const requestData = {
        commonInfo: {
          jigyoshoCd: this.userInfo.jigyoshoData.jigyoshoCd,
          genzaiYmd: this.userInfo.onlineData.genzaiYmd,
        },
        zaikoIdoIraiData: {
          zaikoIdoIraiJigyoshoCd,
          zaikoIdoIraiEntryYmd: dateStrToNum(zaikoIdoIraiEntryYmd),
          zaikoIdoIraiNo: zaikoIdoIraiNo,
          zaikoIdoIraiShuseiCount,
          nyukoSokoCd,
          nyukoKiboYmd: dateStrToNum(nyukoKiboYmd),
          zaikoIdoIraiBiko,
          detailData,
          ...(this.isUpd && {
            koshinCountDetailSum: childHeaderInput.koshinCountDetailSum, // only Upd
          }),
        },
      } as any;

      const actionName = this.isUpd
        ? 'g090/putZaikoIdoIraiEntryItem'
        : 'g090/postZaikoIdoIraiEntry';
      const res = await this.$store.dispatch(actionName, requestData);
      this.$store.dispatch('common/setIsLoading', false);

      if (
        res &&
        res.status == 200 &&
        res.data &&
        res.data.error &&
        res.data.error.messageID &&
        res.data.error.outStatus &&
        res.data.error.outStatus != OutStatus.NORMAL
      ) {
        const { error } = res.data;
        if (error.outStatus == OutStatus.CHECK_ERR) {
          this.messageShow = true;
          this.messageId = error.messageID;
          this.messageTextParam = error.messageArgs;
          return;
        } else if (error.outStatus == OutStatus.EXCLUSIVE_ERR) {
          this.messageShow = true;
          this.messageId = error.messageID;
          this.messageTextParam = error.messageArgs;
          this.isReload = true;
          return;
        }
      }
      this.hide();
    },
    async checkValidate() {
      await new Promise((resolve) => setTimeout(resolve, 300));
      this.$refs.form.validate();

      const childHeaderInput = this.childHeaderInput;

      if (!childHeaderInput.gyoshuCd) {
        this.messageId = 'KI_W100';
        this.messageTextParam = ['業種'];
        this.messageShow = true;
        return;
      }
      if (!childHeaderInput.nyukoSokoCd) {
        this.messageId = 'KI_W100';
        this.messageTextParam = ['依頼倉庫'];
        this.messageShow = true;
        return;
      }
      if (!dateStrToNum(childHeaderInput.nyukoKiboYmd)) {
        this.messageId = 'KI_W100';
        this.messageTextParam = ['納品希望日'];
        this.messageShow = true;
        return;
      }
      if (!childHeaderInput.zaikoIdoIraiD.length) {
        this.messageId = 'KI_W113';
        this.messageTextParam = ['明細'];
        this.messageShow = true;
        return;
      }
      if (
        dateStrToNum(childHeaderInput.nyukoKiboYmd) <
        this.userInfo.onlineData.genzaiYmd
      ) {
        this.messageId = 'KI_W109';
        this.messageTextParam = ['納品希望日', '過去日'];
        this.messageShow = true;
        return;
      }
      if (
        this.childHeaderInput.zaikoIdoIraiD &&
        this.childHeaderInput.zaikoIdoIraiD.length > 99
      ) {
        this.messageId = 'KI_W104';
        this.messageTextParam = ['99行', '明細'];
        this.messageShow = true;
        return;
      }
      if (!this.$refs.form.validate()) {
        this.messageId = 'KI_W121';
        this.messageTextParam = [];
        this.messageShow = true;
        return;
      }
      this.messageConfirmSubmit = true;
      this.messageId = 'KI_Q100';
      this.messageTextParam = [this.isUpd ? '変更' : '追加'];
      this.messageShow = true;
    },
    async getGyoshuItems() {
      await this.$store
        .dispatch('common/getGyoshuMst', {
          mukoUmuFlg: this.isRef ? UmuFlg.ARI : UmuFlg.NASHI,
        })
        .then((res: any) => {
          let gyoshuItems = [] as any;
          if (res.data.responseData && res.data.responseData.length > 0)
            gyoshuItems = res.data.responseData;
          this.gyoshuItems = gyoshuItems;
        });
    },
    async getShukasakiSokoItems() {
      await this.$store
        .dispatch('common/getShukasakiSoko', {
          shiiresakiCd: this.userInfo.shiiresakiCd,
          mukoUmuFlg: UmuFlg.NASHI,
        })
        .then((res: any) => {
          let shukasakiSokoItems = [] as any;
          if (res.data.responseData && res.data.responseData.length > 0)
            shukasakiSokoItems = res.data.responseData;
          this.shukasakiSokoItems = shukasakiSokoItems;
        });
    },
    async getData() {
      this.$store.dispatch('common/setIsLoading', true);
      const {
        zaikoIdoIraiJigyoshoCd,
        zaikoIdoIraiEntryYmd,
        zaikoIdoIraiNo,
        zaikoIdoIraiShuseiCount,
      } = this.childItem;

      const params = {
        zaikoIdoIraiJigyoshoCd,
        zaikoIdoIraiEntryYmd: dateStrToNum(zaikoIdoIraiEntryYmd),
        zaikoIdoIraiNo: zaikoIdoIraiNo,
        zaikoIdoIraiShuseiCount,
      };
      const res = await this.$store.dispatch(
        'g090/getZaikoIdoIraiEntryItem',
        params
      );
      this.$store.dispatch('common/setIsLoading', false);
      if (
        res &&
        res.status == 200 &&
        res.data &&
        res.data.error &&
        res.data.error.outStatus &&
        res.data.error.outStatus != OutStatus.NORMAL
      ) {
        this.messageId = res.data.error.messageID;
        this.messageTextParam = res.data.error.messageArgs;
        this.messageShow = true;
        this.isReload = true;
        return;
      }

      if (
        this.isUpd &&
        res.data.responseData.koshinCountDetailSum !==
          this.childHeaderInput.koshinCountDetailSum
      ) {
        this.messageId = 'KI_W107';
        this.messageTextParam = [];
        this.messageShow = true;
        this.isReload = true;
        return;
      }

      this.childHeaderInput = {
        ...this.childHeaderInput,
        ...res.data.responseData,
      };
    },
  },
  async created() {
    this.childHeaderInput = {
      ...this.childHeaderInput,
      ...this.childItem,
    };
    this.$store.dispatch('common/getChildHeaderTitle', {
      shoriKb: this.shoriKb,
    });
    await Promise.all([this.getGyoshuItems(), this.getShukasakiSokoItems()]);
    if (!this.isAdd) {
      this.getData();
    }
  },
});
